// ts-gql-integrity:093dfc92278d77d127631f7d0185132c
/*
ts-gql-meta-begin
{
  "hash": "7fd6b4712702d1d04737cf93ac69b526"
}
ts-gql-meta-end
*/

import * as SchemaTypes from "./@schema";
import { TypedDocumentNode } from "@ts-gql/tag";

type TenantRolesAndProductsQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


type TenantRolesAndProductsQuery = { readonly __typename: 'Query', readonly getTenantRoleList: ReadonlyArray<{ readonly __typename: 'TenantRole', readonly roleName: string | null, readonly roleDescription: string | null }> | null, readonly getTenantProductList: ReadonlyArray<{ readonly __typename: 'TenantProduct', readonly productId: string | null, readonly friendlyName: string | null, readonly internalName: string | null }> | null };



export type type = TypedDocumentNode<{
  type: "query";
  result: TenantRolesAndProductsQuery;
  variables: {};
  documents: SchemaTypes.TSGQLDocuments;
  fragments: SchemaTypes.TSGQLRequiredFragments<"none">
}>

declare module "./@schema" {
  interface TSGQLDocuments {
    TenantRolesAndProducts: type;
  }
}

export const document = JSON.parse("{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"TenantRolesAndProducts\"},\"variableDefinitions\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"getTenantRoleList\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"roleName\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"roleDescription\"},\"arguments\":[],\"directives\":[]}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"getTenantProductList\"},\"arguments\":[],\"directives\":[],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"productId\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"friendlyName\"},\"arguments\":[],\"directives\":[]},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"internalName\"},\"arguments\":[],\"directives\":[]}]}}]}}]}")
